;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockTwoColumnGrid from './BlockTwoColumnGrid';

const query = /* GraphQL */ `
    ${ctaFragment}
    ${linkFragment}
    ${assetFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockTwoColumnGrid(preview: $preview, id: $id) {
            __typename
            icon {
                ... on Icon {
                    ...Icon
                }
            }
            eyebrow
            headline {
                json
            }
            body {
                json
            }
            cta {
                ...CTA
            }
            image {
                ...Asset
            }
            imagePosition
            flushTop
            flushBottom
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockTwoColumnGrid },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockTwoColumnGrid;
}

const BlockTwoColumnGridServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return <BlockTwoColumnGrid {...block} />;
};

export default BlockTwoColumnGridServer;
